<template>
  <div class="eventsList">
    <!-- 页头 -->
    <div class="page-header-style">
      <el-page-header @back="goBack" :content="$t('lang.title_eventsList')"></el-page-header>
    </div>
    <!-- 筛选 -->
    <div class="filters">
      <el-form :inline="true" label-suffix=":">
        <!-- 赛事项目input -->
        <el-form-item :label="$t('lang.lab_competeItem')">
          <input style="display: none"/>
          <el-input v-model="itemName" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_competeItem')"></el-input>
        </el-form-item>
        <!-- 比赛项select -->
        <el-form-item :label="$t('lang.lab_competeEvent')">
          <el-select v-model="eventId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeEvent')">
            <el-option
              v-for="(item,index) in eventNames"
              :key="index"
              :value="item.id"
              :label="item.eventName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 组别select -->
        <el-form-item :label="$t('lang.lab_competeGroup')">
          <el-select v-model="groupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeGroup')">
            <el-option
              v-for="(item,index) in groupNames"
              :key="index"
              :value="item.id"
              :label="item.groupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 年龄段select -->
        <el-form-item :label="$t('lang.lab_competeAgeGroup')">
          <el-select v-model="ageGroupId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeAgeGroup')">
            <el-option
              v-for="(item,index) in ageNames"
              :key="index"
              :value="item.id"
              :label="item.ageGroupName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="onSearch(true,true)">{{$t('lang.btn_search')}}</el-button>
        <!-- 重置 -->
        <el-button type="primary" @click="onClear">{{$t('lang.btn_reset')}}</el-button>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-card>
      <!-- 新增 -->
      <el-button type="primary" slot="header" @click="onAdd">{{$t('lang.btn_add')}}</el-button>
      <!-- 删除 -->
      <el-button type="primary" slot="header" @click="onDelete">{{$t('lang.btn_delete')}}</el-button>
      <!-- 白名单模板导出 -->
      <el-button type="primary" slot="header" @click="onwhiteList">{{$t('lang.btn_whiteList')}}</el-button>
      <!-- 秩序单导出 -->
      <el-button type="primary" slot="header" @click="onOrder">{{$t('lang.btn_orderlistexpor')}}</el-button>
      <!-- 成绩导出 -->
      <el-button type="primary" slot="header" @click="onResult">{{$t('lang.btn_resultexport')}}</el-button>
      <el-table
        class="wid100"
        :data="tableData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @sort-change="changeTableSort"
      >
        <!-- 复选框 -->
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <!-- 赛事项目 -->
        <el-table-column prop="itemName" :label="$t('lang.lab_competeItem')" :sortable="'custom'"></el-table-column>
        <!-- 场次 -->
        <el-table-column prop="competeNumberName" :label="$t('lang.lab_sessions')"  :sortable="'custom'"></el-table-column>
        <!-- 报名上限 -->
        <el-table-column prop="enrollLimit" :label="$t('lang.lab_enrollLimit')"  :sortable="'custom'"></el-table-column>
        <!-- 已报人数 -->
        <el-table-column prop="enrollNum" :label="$t('lang.lab_enrollNums')" :sortable="'custom'">
          <template slot-scope="scope">
            <el-link type="primary" @click="linkGroup(scope.row)">{{ scope.row.enrollNum | valueIsNull}}</el-link>
          </template>
        </el-table-column>
        <!-- 白名单 -->
        <el-table-column prop="whiteList" :label="$t('lang.lab_whiteList')" >
          <template slot-scope="scope">
            <span v-if="scope.row.whiteList === true">
              <el-button @click="downwhiteList(scope.row.id,scope.row.itemName)">{{$t('lang.btn_downwhiteList')}}</el-button>
              <el-button @click="touchUpload(scope.row.id)">{{$t('lang.btn_changewhiteList')}}</el-button>
              <input type="file" class="dis-none" id="upload" @change="upload($event,scope.row.id)" />
              <el-button
                class="mar-lef10"
                @click="deletewhiteList(scope.row.id)"
              >{{$t('lang.btn_deletewhiteList')}}</el-button>
            </span>
            <span v-else>
              <div>
                <el-button type="primary" @click="addtouchUpload(scope.row.id)">{{$t('lang.btn_addwhiteList')}}</el-button>
              </div>
              <input
                type="file"
                class="dis-none"
                id="addupload"
                @change="addupload($event,scope.row.id)"
              />
            </span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" fixed="right" >
          <template slot-scope="scope">
            <el-button @click="onEdit(scope.row)">{{$t('lang.btn_edit')}}</el-button>
            <el-button @click="onUpdateRecord(scope.row.id)">{{$t('lang.btn_updateRecord')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </el-card>
    <!-- 新增编辑 -->
    <el-dialog 
      :title="isTitle"
      :visible.sync="isShow" 
      :close-on-click-modal="false"
      :destroy-on-close="true"
      center
      top="130px"
      width="600px"
      v-if="isShow"
      @close="handleDialogClosed">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-suffix=":">
        <!-- 赛事项目 -->
        <el-form-item prop="competeItemListId" :label="$t('lang.lab_competeItem')">
          <el-select v-model="form.competeItemListId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_competeItem')">
            <el-option
              v-for="(item,index) in competeNames"
              :key="index"
              :value="item.id"
              :label="item.itemName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 场次 -->
        <el-form-item prop="competeNumberId" :label="$t('lang.lab_sessions')">
          <el-select v-model="form.competeNumberId" :placeholder="$t('lang.pla_pleaseSelect')+$t('lang.lab_sessions')">
            <el-option
              v-for="(item,index) in sessionNames"
              :key="index"
              :value="item.id"
              :label="item.competeNumberName">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 排序 -->
        <el-form-item prop="itemOrder" :label="$t('lang.lab_order')">
          <input style="display: none"/>
          <el-input v-model="form.itemOrder" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_order')" maxlength="5"  @input="keyitemOrder"></el-input>
        </el-form-item>
        <!-- 报名上限 -->
        <el-form-item prop="enrollLimit" :label="$t('lang.lab_enrollLimit')">
          <input style="display: none"/>
          <el-input v-model="form.enrollLimit" :placeholder="$t('lang.pla_pleaseInput')+$t('lang.lab_enrollLimit')" maxlength="5"  @input="keyEnrollLimit"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="toCancel">{{$t('lang.btn_cancel')}}</el-button>
        <el-button type="primary" @click="toSave('form')" :disabled="isDisabled">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
/**
 *@ClassName:eventsList
 *@Description:赛事项目
 *@author:宋莎
 *@Copyright:美再晨
 *@date:2020-07-14
 */

// import { parseTime } from '@/utils/setMethods.js'
import { excelDownload } from '../../config/download.js'
export default {
  name: '',
  components: {},
  data() {
    return {
      idUp: '', // 上传id 
      competeId: '', // 赛事id
      isShow: false, // 新增编辑dialog的显示控制
      isTitle: this.$i18n.t('lang.btn_add'), // 新增编辑dialog的title
      isDisabled: true, // 确定按钮置灰
      /* 赛事项目列表变量 */
      multipleSelection: [], // 复选框
      pageNum: 1, // 页数
      pageSize: 50, // 每页显示数量
      total: 0, // 数据总数
      eventNames: [], // 比赛项下拉list
      ageNames: [], // 年龄段下拉list
      groupNames: [], // 组别下拉list
      itemName: '', // 筛选-赛事项目
      eventId: '', // 筛选-比赛项
      ageGroupId: '', // 筛选-年龄段
      groupId: '', // 筛选-组别
      sortName: '', // 升序/降序
      sortFieldName: '', // 排序字段
      tableData: [], // 列表数据
      /* 记忆筛选项值 */
      itemName_bak: '', // 备份-赛事项目
      eventId_bak: '', // 备份-比赛项
      groupId_bak: '', // 备份-年龄段
      ageGroupId_bak: '', // 备份-组别
      /* 赛事项目详情(新建编辑)变量 */
      rules: {
        competeItemListId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeItemName'), trigger: 'change' }],
        competeNumberId: [{ required: true, message: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_sessions'), trigger: 'change' }],
        enrollLimit: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_enrollLimit'), trigger: 'blur' }],
        itemOrder: [{ required: true, message: this.$i18n.t('lang.pla_pleaseInput') + this.$i18n.t('lang.lab_order'), trigger: 'blur' }],
      },     
      competeNames: [], // 赛事项目下拉list
      sessionNames: [], // 场次下拉list
      form: {
        id: '',
        competeId: '',
        competeItemListId: '',
        competeNumberId: '',
        enrollLimit: '',
        itemOrder: '',
      }, // 详细数据
        // 存储筛选值和页码
      eventsListParam: {
        pageNum: 1,
        pageSize: 50,
        itemName: '',
        eventId: '',
        groupId: '',
        ageGroupId: '',
        sortName: '',
        sortFieldName: '',
      },
    }
  },
  computed: {},
  watch: {
    form: {
      handler(newVal, oldVal) {
        let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 白名单模板导出
    onwhiteList() {
      const tHeader = [
        this.$i18n.t('lang.lab_index'),
        this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_name'),
        this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_certificateType'),
        this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_certificateNum'),
      ]
      excelDownload(tHeader, [], [], this.$i18n.t('lang.btn_whiteList'))
    },
    // 秩序单导出
    onOrder() {
      this.$get(`/item/orderList?competeId=${this.competeId}`).then(
        res => {
          if (res && res.code === 200) {
            var aSnapshot = document.createElement('a')
            aSnapshot.setAttribute('href', res.data)
            aSnapshot.setAttribute('download', '')
            aSnapshot.click()
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
      //  var excelDatas = []
      //  for (let i = 0; i < this.list1.length; i++) {
      //    excelDatas.push({
      //      tHeader: [this.$i18n.t('lang.lab_name'), this.$i18n.t('lang.lab_certificateType'), this.$i18n.t('lang.lab_certificateNum'), this.$i18n.t('lang.lab_phone'), this.$i18n.t('lang.lab_group'), this.$i18n.t('lang.lab_swimLane')], // sheet表一头部
      //      filterVal: ['id', 'title', 'author', 'title', 'author', 'author'], // 表一的数据字段
      //      tableDatas: this.list1[i].list, // 表一的整体json数据
      //      sheetName: this.list1[i].sheetName// 表一的sheet名字
      //    })
      //   }
      //   this.json2excel(excelDatas, '秩序单', true, 'xlsx')
    },
    // 成绩导出
    onResult() {
      this.$get(`/item/resultList?competeId=${this.competeId}`).then(
        res => {
          if (res && res.code === 200) {
            var aSnapshot = document.createElement('a')
            aSnapshot.setAttribute('href', res.data)
            aSnapshot.setAttribute('download', '')
            aSnapshot.click()
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
      // var excelDatas = []
      // for (let i = 0; i < this.list1.length; i++) {
      //   excelDatas.push({
      //     tHeader: [this.$i18n.t('lang.lab_name'), this.$i18n.t('lang.lab_certificateType'), this.$i18n.t('lang.lab_certificateNum'), this.$i18n.t('lang.lab_phone'), this.$i18n.t('lang.lab_group'), this.$i18n.t('lang.lab_swimLane')], // sheet表一头部
      //     filterVal: ['id', 'title', 'author', 'title', 'author', 'author'], // 表一的数据字段
      //     tableDatas: this.list1[i].list, // 表一的整体json数据
      //     sheetName: this.list1[i].sheetName// 表一的sheet名字
      //     })
      // }
      // this.json2excel(excelDatas, '成绩', true, 'xlsx')
    },
  //  json2excel (tableJson, filenames, autowidth, bookTypes) {
  //     var that = this
  //     // 这个是引用插件
  //     import('@/vendor/Export2Excel1').then(excel => {
  //       var tHeader = []
  //       var dataArr = []
  //       var sheetnames = []
  //       for (var i in tableJson) {
  //         tHeader.push(tableJson[i].tHeader)
  //         dataArr.push(that.formatJson(tableJson[i].filterVal, tableJson[i].tableDatas))
  //         sheetnames.push(tableJson[i].sheetName)
  //       }
  //       excel.export_json_to_excel({
  //         header: tHeader,
  //         data: dataArr,
  //         sheetname: sheetnames,
  //         filename: filenames,
  //         autoWidth: autowidth,
  //         bookType: bookTypes
  //       })
  //     })
  //   },
    // 数据过滤，时间过滤
    // formatJson (filterVal, jsonData) {
    //   return jsonData.map(v => filterVal.map(j => {
    //     if (j === 'timestamp') {
    //       return parseTime(v[j])
    //     } else {
    //       return v[j]
    //     }
    //   }))
    // },
    // 下载文件
    downwhiteList(id, itemName) {
      this.$postJson(
        `/player/playerWhiteList/get?competeId=${parseInt(this.competeId)}&competeItemId=${id}`
      ).then(
        res => {
          if (res && res.code === 200) {
            // 选手成绩列表
            this.allData = res.data
            if (this.allData.length > 0) {
            for (let i = 0; i < this.allData.length; i++) {
              // 判断证件类型
               this.allData[i].ids = i + 1
                if (this.allData[i].idType === '0') {
                  this.allData[i].type = this.$i18n.t('lang.MeetingRecordDetail_idType[0].name')
                } else if (this.allData[i].idType === '1') {
                  this.allData[i].type = this.$i18n.t('lang.MeetingRecordDetail_idType[1].name')
                } else if (this.allData[i].idType === '2') {
                  this.allData[i].type = this.$i18n.t('lang.MeetingRecordDetail_idType[2].name')
                } else if (this.allData[i].idType === '3') {
                  this.allData[i].type = this.$i18n.t('lang.MeetingRecordDetail_idType[3].name')
                } 
            }
            }
            // Excel表头
            const tHeader = [
              this.$i18n.t('lang.lab_index'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_name'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_certificateType'),
              this.$i18n.t('lang.lab_star') + this.$i18n.t('lang.lab_certificateNum'),
            ]
            // 对应table数据的列字段名
            const filterVal = [
              'ids',
              'idName',
              'type',
              'idCard',
            ]
            excelDownload(tHeader, filterVal, this.allData, itemName + this.$i18n.t('lang.lab_playerInfoList'))
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 按钮点击更改文件
    touchUpload(id) {
      if (this.type == 'file') {
        if (this.$parent.$parent.$parent.mobileDebugAppInstallIng) {
          this.$message.error('正在上传，请稍后再上传！')
          return
        }
      }
      this.idUp = id
      let inputId = document.getElementById('upload')
      inputId && inputId.click()
    },
    // 按钮点击添加文件
    addtouchUpload(id) {
     if (this.type == 'file') {
        if (this.$parent.$parent.$parent.mobileDebugAppInstallIng) {
          this.$message.error('正在上传，请稍后再上传！')
          return
        }
      }
      this.idUp = id
      let addupload = document.getElementById('addupload')
      console.log(addupload)
      addupload && addupload.click()
    },
    // 添加文件上传
    addupload(e) {
      if (!e.target.files[0]) {
        return
      }
      let file = e.target.files[0]
      let filename = file.name
      if (
        filename.substring(filename.length - 3, filename.length) == 'xls' ||
        filename.substring(filename.length - 3, filename.length) == 'lsx'
      ) {
        setTimeout(() => {
          let formData = new FormData()
          formData.append('files', file)
          formData.append('competeId', parseInt(this.competeId))
          formData.append('competeItemId', this.idUp)
          this.$postFormData('/player/playerWhiteList/add', formData).then(
            res => {
              if (res && res.code === 200) {
                this.getData()
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        }, 500)
        this.name = filename
        this.clearFileadd()
      } else {
        this.$message.error('请上传.xls或者.xlsx格式文件。')
        this.clearFileadd()
      }
    },
    // 更改文件上传
    upload(e) {
     if (!e.target.files[0]) {
        return
      }
      let file = e.target.files[0]
      let filename = file.name
      if (
        filename.substring(filename.length - 3, filename.length) == 'xls' ||
        filename.substring(filename.length - 3, filename.length) == 'lsx'
      ) {
        setTimeout(() => {
          let formData = new FormData()
          formData.append('files', file)
          formData.append('competeId', parseInt(this.competeId))
          formData.append('competeItemId', this.idUp)
          this.$postFormData('/player/playerWhiteList/change', formData).then(
            res => {
              if (res && res.code === 200) {
                this.getData()
                this.$message.success('更換成功')
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        }, 500)
        this.name = filename
        this.clearFile()
      } else {
        this.$message.error('请上传.xls或者.xlsx格式文件。')
        this.clearFile()
      }
    },
    // 更改文件删除原文件change事件用
    clearFile() {
      var obj = document.getElementById('upload')
      if (obj.value) {
        try {
          obj.value = '' // for IE11, latest Chrome/Firefox/Opera...
        } catch (err) {}
        if (obj.value) {
          // for IE5 ~ IE10
          var form = document.createElement('form')
          var ref = obj.nextSibling
          var p = obj.parentNode
          form.appendChild(obj)
          form.reset()
          p.insertBefore(obj, ref)
        }
      }
    },
    // 添加文件删除原文件change事件用
    clearFileadd() {
      var obj = document.getElementById('addupload')
      if (obj.value) {
        try {
          obj.value = '' // for IE11, latest Chrome/Firefox/Opera...
        } catch (err) {}
        if (obj.value) {
          // for IE5 ~ IE10
          var form = document.createElement('form')
          var ref = obj.nextSibling
          var p = obj.parentNode
          form.appendChild(obj)
          form.reset()
          p.insertBefore(obj, ref)
        }
      }
    },
    // 删除
    deletewhiteList(id) {
      this.$postJson(
        `/player/playerWhiteList/delete?competeId=${parseInt(
          this.competeId
        )}&competeItemId=${id}`
      ).then(
        res => {
          if (res && res.code === 200) {
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事项目列表数据
    getData() {
      this.itemName = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).itemName ? JSON.parse(window.localStorage.getItem('eventsListParam')).itemName : ''
      this.itemName_bak = this.itemName 
      this.eventId = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).eventId ? JSON.parse(window.localStorage.getItem('eventsListParam')).eventId : ''
      this.eventId_bak = this.eventId 
      this.groupId = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).groupId ? JSON.parse(window.localStorage.getItem('eventsListParam')).groupId : ''
      this.groupId_bak = this.groupId 
      this.ageGroupId = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).ageGroupId ? JSON.parse(window.localStorage.getItem('eventsListParam')).ageGroupId : ''
      this.ageGroupId_bak = this.ageGroupId 
      this.pageNum = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).pageNum ? JSON.parse(window.localStorage.getItem('eventsListParam')).pageNum : 1
      this.pageSize = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).pageSize ? JSON.parse(window.localStorage.getItem('eventsListParam')).pageSize : 50
       this.sortName = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).sortName ? JSON.parse(window.localStorage.getItem('eventsListParam')).sortName : ''
      this.sortFieldName = window.localStorage.getItem('eventsListParam') && JSON.parse(window.localStorage.getItem('eventsListParam')).sortFieldName ? JSON.parse(window.localStorage.getItem('eventsListParam')).sortFieldName : ''
      this.$get(`/item/compete/filterItem?competeId=${this.competeId}&pageNum=${this.pageNum}&pageSize=${this.pageSize}&itemName=${this.itemName}&eventId=${this.eventId}&groupId=${this.groupId}&ageGroupId=${this.ageGroupId}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取年龄段下拉list
    getAgeList() {
      this.$get('/itemAge/itemAge').then(
        res => {
          if (res && res.code === 200) {
            this.ageNames = res.data.list
            let newValue = {
              id: '',
              ageGroupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeAgeGroup')
            }
            this.ageNames.unshift(newValue)   
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取组别下拉list
    getGroupList() { 
      this.$get('/itemGroup/itemGroup').then(
        res => {
          if (res && res.code === 200) {
            this.groupNames = res.data.list
            let newValue = {
              id: '',
              groupName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeGroup')
            }
            this.groupNames.unshift(newValue)       
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取比赛项下拉list
    getEventList() {
      this.$get('/itemEvent/itemEvent').then(
        res => {
          if (res && res.code === 200) {
            this.eventNames = res.data.list
            let newValue = {
              id: '',
              eventName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeEvent')
            }
            this.eventNames.unshift(newValue)       
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取赛事项目下拉list
    getCompeteList() {
      let params = {}
      this.$postJson('/item/all/filterItem', params).then(
        res => {
          if (res && res.code === 200) {
            this.competeNames = res.data.list
            let newValue = {
              id: '',
              itemName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_competeItem')
            }
            this.competeNames.unshift(newValue)   
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 获取场次下拉list
    getSessionList() {
      this.$get(`/competeNum/filterCompeteNum?competeId=${this.competeId}`).then(
        res => {
          if (res && res.code === 200) {
            this.sessionNames = res.data.list
            let newValue = {
              id: '',
              competeNumberName: this.$i18n.t('lang.pla_pleaseSelect') + this.$i18n.t('lang.lab_sessions')
            }
            this.sessionNames.unshift(newValue)   
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
        // 赋值存储
    setDataLoacal() {
      this.eventsListParam.pageNum = this.pageNum
      this.eventsListParam.pageSize = this.pageSize
      this.eventsListParam.itemName = this.itemName
      this.eventsListParam.eventId = this.eventId
      this.eventsListParam.groupId = this.groupId
      this.eventsListParam.ageGroupId = this.ageGroupId
      this.eventsListParam.sortName = this.sortName
      this.eventsListParam.sortFieldName = this.sortFieldName
       // 点击搜索存储搜索内容，用于不刷新时默认展示-退出登录等页面功能均已清除全部缓存，不需要额外清除此缓存
      window.localStorage.setItem('eventsListParam', JSON.stringify(this.eventsListParam))
    },
    // 查询
    onSearch(flag, isSearch) { 
      if (flag) {
        this.pageNum = 1
      }
     this.setDataLoacal()
      if (isSearch) {
        // 记忆筛选项值
        this.itemName_bak = this.itemName
        this.eventId_bak = this.eventId
        this.groupId_bak = this.groupId
        this.ageGroupId_bak = this.ageGroupId
      } else { 
        // 筛选项正确显示
        this.itemName = this.itemName_bak
        this.eventId = this.eventId_bak
        this.groupId = this.groupId_bak
        this.ageGroupId = this.ageGroupId_bak
      }
      this.$get(`/item/compete/filterItem?competeId=${this.competeId}&itemName=${this.itemName}&eventId=${this.eventId}&groupId=${this.groupId}&ageGroupId=${this.ageGroupId}&sortName=${this.sortName}&sortFieldName=${this.sortFieldName}&pageNum=${this.pageNum}&pageSize=${this.pageSize}`).then(
        res => {
          if (res && res.code === 200) {
            this.total = res.data.total
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        },
        error => {
          this.$message.error(error)
        }
      )      
    },
    // 重置
    onClear() {
      this.itemName = ''
      this.eventId = ''
      this.groupId = ''
      this.ageGroupId = ''
      this.itemName_bak = ''
      this.eventId_bak = ''
      this.groupId_bak = ''
      this.ageGroupId_bak = ''
      this.sortName = ''
      this.sortFieldName = ''
      this.pageNum = 1
      this.pageSize = 50
      this.setDataLoacal()
      this.getData()
    },
    // 新增
    onAdd() {
      console.log('onAdd')
      this.isTitle = this.$i18n.t('lang.btn_add')
      this.form.id = ''
      this.form.competeId = ''
      this.form.competeItemListId = ''
      this.form.competeNumberId = ''
      this.form.enrollLimit = ''
      this.form.itemOrder = ''
      this.isShow = true
    },
    // 删除
    onDelete() {
      console.log('onDelete')
      var array = []
      for (let index = 0; index < this.multipleSelection.length; index++) {
        array.push(this.multipleSelection[index].id)
      }
      if (array.length === 0) {
        this.$message.error(this.$i18n.t('lang.warning_selectOneDelete'))
        return        
      }
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_isDelete'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$delete(`/item/compete/item/${array}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_delSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_delCancel')
          })
        })  
    },
    // 编辑
    onEdit(data) {
      console.log('onEdit', data)
      this.isTitle = this.$i18n.t('lang.btn_edit')
      this.form.id = data.id
      this.form.competeId = data.competeId
      this.form.competeItemListId = data.competeItemListId
      this.form.competeNumberId = data.competeNumberId
      this.form.enrollLimit = data.enrollLimit
      this.form.itemOrder = data.itemOrder
      // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
      this.saveData = JSON.stringify(this.form)
      this.isShow = true
    },
    // 更新赛会纪录
    onUpdateRecord(id) {
      console.log('onUpdateRecord')
      let loading = this.$loading()
      this.$confirm(this.$i18n.t('lang.lab_updateRecord'), this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          this.$postJson(`/player/offLine/updateRecord?competeItemId=${id}`).then(
            res => {
              loading.close()
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_updateSuccess')
                })
                // 更新tableData
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )   
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_updateCancel')
          })
        })  
    },
    // 保存
    toSave(formName) {
      console.log('toSave')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.competeId = this.competeId
          let params = this.form
          this.$postJson('/item/compete/item', params).then(
            res => {
              if (res && res.code === 200) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_modifySuccess')
                })
                this.handleDialogClosed()
                // 更新列表
                this.onSearch(true, false)
              } else {
                this.$message.error(res.message)
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 取消
    toCancel() {
      console.log('toCancel')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeId = ''
      this.form.competeItemListId = ''
      this.form.competeNumberId = ''
      this.form.enrollLimit = ''
      this.form.itemOrder = ''
    },
    // 进入选手分组管理页面
    linkGroup(data) {
      console.log('选手分组管理', data)
      window.localStorage.setItem('competeItemPageSize', JSON.stringify(this.pageSize))
      window.localStorage.setItem('competeItemPageNum', JSON.stringify(this.pageNum))
      this.$router.push({ name: 'groups', query: { competeItemId: data.id, competeId: this.competeId, competeItemName: data.itemName } })
    },
    // 报名上限 输入限制
    keyEnrollLimit() {
      // 仅保留数字
      this.form.enrollLimit = this.form.enrollLimit.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.enrollLimit.indexOf('.') < 0 && this.form.enrollLimit !== '') { 
        this.form.enrollLimit = parseFloat(this.form.enrollLimit)
      }
    },
    // 排序输入限制
    keyitemOrder() {
      // 仅保留数字
      this.form.itemOrder = this.form.itemOrder.replace(/[^\d]/g, '') 
      // 首位是0的话去掉
      if (this.form.itemOrder.indexOf('.') < 0 && this.form.itemOrder !== '') { 
        this.form.itemOrder = parseFloat(this.form.itemOrder)
      }
    },
    // 监听关闭'新建编辑'dialog
    handleDialogClosed() {
      console.log('handleDialogClosed')
      this.isShow = false
      this.$refs.form.clearValidate()
      this.form.id = ''
      this.form.competeId = ''
      this.form.competeItemListId = ''
      this.form.competeNumberId = ''
      this.form.enrollLimit = ''
      this.form.itemOrder = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.onSearch(false, false)
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.onSearch(false, false)
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      console.log('多选', val)
      this.multipleSelection = val
    },
    // 监听表格排序
    changeTableSort(column) {
      console.log('排序', column)
      // 将排序传给后台
      this.sortName = column.order
      this.sortFieldName = column.prop
      this.onSearch(true, false)
    },
    // 返回
    goBack() {
      window.history.go(-1)
    }
  },
  created() {
    // 初始进入
      this.pageNum = JSON.parse(localStorage.getItem('competeItemPageNum'))
      this.pageSize = JSON.parse(localStorage.getItem('competeItemPageSize'))
      this.competeId = this.$route.query.id
      if (this.competeId !== '') {
        this.getData()
      }
      this.getAgeList()
      this.getGroupList()
      this.getEventList()
      this.getCompeteList()
      this.getSessionList()
  },
  mounted() {
  },
  destroyed() {
     // 是否重置搜索项：如果tab不是offline，说明跳转别的tab，需要重置--1；如果是offline，说明进入了详情，保存搜索项和页码---0
    var clearRefresh = JSON.parse(window.localStorage.getItem('tabsValue')) !== 'offline' ? 1 : 0
    if (clearRefresh == 1) {
      this.pageNum = 1
      this.pageSize = 50
      this.itemName = ''
      this.eventId = ''
      this.ageGroupId = ''
      this.setDataLoacal()
    }
  }
}
</script>

<style lang='scss'>
.eventsList {
 .file-upload-input {
    background-color: transparent;
    position: absolute;
    width: 999px;
    height: 999px;
    top: -10px;
    right: -10px;
    cursor: pointer;
  }
  .mar-lef10 {
    margin-left: 10px;
  }
  .dis-none {
    display: none;
  }
}
</style>
